<template>
    <Tabs type="card">
        <TabPane label="小程序数据">
			<ToutiaoAdvData ref="ToutiaoAdvData"></ToutiaoAdvData>
		</TabPane>
		<TabPane label="畅开花" >
			<ChangkaihuaData ref="ChangkaihuaData"></ChangkaihuaData>
		</TabPane>
    </Tabs>	
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import ToutiaoAdvData from './ToutiaoAdvData.vue';
	import ChangkaihuaData from '../advManage/ChangkaihuaData.vue';
	export default {
		name:"sectorSetup",
		components: {
			ToutiaoAdvData,
			ChangkaihuaData,
		},
		computed: {
			...mapGetters([
				'userInfo', 'token'
			]),
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
		}
	}
</script>

<style>
</style>
